import { LayoutProps } from "./types/layout.types";
import GlobalLayout from "./GlobalLayout";

import EliteFooter from "./~elite-includes/EliteFooter";
import EliteHeader from "./~elite-includes/EliteHeader";

import EliteMobileNav from "./~elite-includes/EliteMobileNav";
import EliteTopNav from "./~elite-includes/EliteTopNav";


const EliteLayout = ({ children, title = "" }: LayoutProps) => (
  <GlobalLayout title={title}>
    <EliteHeader />

    <section className="hidden sm:block">
      <EliteTopNav />
    </section>

    <section className="sm:hidden">
      <EliteMobileNav />
    </section>

    <main className="lg:py-5 sm:py-10 xl:py-5 bg-hc_F4EBFA dark:bg-slate-500">
      <section className="sm:container sm:mx-auto">{children}</section>
    </main>

    <EliteFooter />
  </GlobalLayout>
);

export default EliteLayout;
